import { SP_VERSION } from "../src/constants/version";
import { SPGameState } from "../src/enum/GameState";
import { SoundByte } from "../src/enum/sounds";
import Engine from "../src/lib/Engine";
import { Input, KeyCode } from "../src/lib/Input";
import MonoBehavior from "../src/lib/MonoBehavior";
import { Time } from "../src/lib/Time";
import { Physics } from "../src/math/Physics";
import Vector2 from "../src/math/Vector2";
import Chain from "../src/scripts/Chain";
import DialogueManager from "../src/scripts/DialogueManager";
import SoundManager from "../src/scripts/SoundManager";
import SPGameManager from "../src/scripts/SPGameManager";
import SPPlayer from "../src/scripts/SPPlayer";
import { FitRectToScreen } from "../src/util";

window.addEventListener("load", () => {

    class SP extends Engine {
        protected onInit(): void {
            this.ctx.imageSmoothingEnabled = false;
            const [, player] = this.NewGameObjectWithScript<SPPlayer>(SPPlayer, {
                position: new Vector2(0, this.height/4)
            });
            this.NewGameObjectWithScript<DialogueManager>(DialogueManager);
            this.NewGameObjectWithScript<SoundManager>(SoundManager);
            this.NewGameObjectWithScript<SPGameManager>(SPGameManager);
        }

        pt = 0;
        protected onBeforeUpdate(): void {
            if ((Input.GetKeyDown(KeyCode.Enter) && Input.GetKey(KeyCode.AltLeft)) || Input.GetKeyDown(KeyCode.F11)) {
                
                document.body.requestFullscreen();
            }

            // if (Input.GetMouseButton(0) && this.pt <= 0) {

            //     const chains = this.GetGameObjectsBehaviors<Chain>(Chain);

            //     const [, segment] = this.NewGameObjectWithScript<Chain>(Chain, {
            //         position: this.mouseWorldPosition
            //     });

            //     if (chains.length) segment.SetParent(chains[chains.length - 1]);
            //     this.pt = 0.2;
            // }

            // if (this.pt > 0) {
            //     this.pt -= Time.deltaTime;
            // }
        }

        

        Resize(): void {
            // this.width = 2560;
            // this.height = 1080;
            this.canvas.width = 960;
            this.canvas.height = 540;

            const scale = Math.min(window.innerWidth/this.width, window.innerHeight/this.height);

            const w = this.width * scale;
            const h = this.height * scale;

            this.canvas.style.width = `${w}px`;
            this.canvas.style.height = `${h}px`;

            this._boundingBox = this.canvas.getBoundingClientRect();
        }

        hue = 0;
        bloom = localStorage.getItem("bBloomEnabled") === 'true' ? true : false;
        
        bg: HTMLImageElement = document.querySelector('img#bg1_img') as HTMLImageElement;
        protected onBeforeDraw(): void {

            //bg image
            // const size = new Vector2(16384, 16384);
            // const pos = this.toScreenPosition(size.scale(-0.5));
            // this.ctx.drawImage(this.bg, 0, 0, this.bg.width, this.bg.height, pos.x, pos.y, size.x, size.y);
            // this.ctx.fillStyle = '#000000a0';
            // this.ctx.fillRect(0, 0, this.width, this.height);
            //

            //background grid
            this.ctx.strokeStyle = "#ffff8033";
            this.ctx.lineWidth = 1;
            const gridSize = 128;
            const modpos = this.camera.clone();
            modpos.x %= gridSize;
            modpos.y %= gridSize;

            for (
                let x = 0;
                x <= this.width - (this.width % gridSize) + gridSize;
                x += gridSize
            ) {
                this.LineScreen(
                    new Vector2(x - modpos.x, 0),
                    new Vector2(x - modpos.x, this.height)
                );
            }

            for (
                let y = 0;
                y <= this.height - (this.height % gridSize) + gridSize;
                y += gridSize
            ) {
                this.LineScreen(
                    new Vector2(0, y - modpos.y),
                    new Vector2(this.width, y - modpos.y)
                );
            }
            //
        }

        protected onAfterDraw(): void {

            // const p1 = Input.mousePosition;
            // const p2 = p1.add(Vector2.down.scale(12));
            // const p3 = p1.add(Vector2.down.rotate(-45*Math.PI/180).scale(12));
            // this.ctx.strokeStyle = 'white';
            // this.strokeShapeScreenPos(p1,p2,p3);

            if (!this.bloom) {
                this.ctx.save();
                // this.ctx.filter = `hue-rotate(${Math.floor(this.hue)}deg)`;
                // this.ctx.drawImage(this.canvas, 0, 0);
                this.ctx.filter = `grayscale(100%) blur(4px)`;
                this.ctx.globalCompositeOperation = 'lighter';
                this.ctx.drawImage(this.canvas, 0, 0);
                this.ctx.restore();
            }

            

            this.drawTexts([
                `${SP_VERSION}`
            ], new Vector2(this.width - 4, 4), {
                align: 'right',
                color: '#ffffff55'
            });

            // this.hue += 360/5 * Time.deltaTime;
        }
    }

    const canvas = document.querySelector('canvas#canvas') as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');

    function Main() {
        const sim = new SP(canvas, {
            background: '#000000',
            foreground: '#55ff55'
        });
    
        sim.drawGizmos = false;
        sim.Start();
    }
    
    Main();

});